<template>
  <div class="policy_warp">
    <myHeader />
    <div class="policy_content">
      <h3>Service agreement</h3>

      <div class="txt">
        <p>Welcome to use hecoos service!</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>In order to use hecoos services, you shall read and comply with the hecoos service agreement (the
          "agreement") and the hecoos privacy policy. Please be sure to read carefully and fully understand the contents
          of each clause, especially the clause that exempts or limits hecoos liability, the clause that restricts
          users' rights, the clause that stipulates dispute resolution and jurisdiction, and the separate agreement or
          rule for opening or using a service. Restrictions, disclaimers or other provisions involving your material
          rights and interests may be in bold, underlined form to remind you to pay attention.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>You are not entitled to use hecoos services unless you have fully read, fully understood and accepted all the
          terms of this agreement. By clicking "agree" or "next", or by using hecoos services, or by any other express
          or implied means of acceptance of this agreement, you are deemed to have read and agreed to sign this
          agreement. This agreement shall have legal effect between you and hecoos and shall become a legal document
          binding on both parties.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>If you do not have full capacity for civil conduct due to age, intelligence or other factors, please read and
          judge whether you agree to this agreement with your legal guardian (hereinafter referred to as the "guardian")
          and pay special attention to the terms of use of minors.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>If you are a user outside mainland China, you are required to enter into or perform this agreement in
          accordance with the laws of your country and/or territory.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>I. scope of agreement</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>1.1 this agreement is an agreement between the user and hecoos regarding the use of hecoos services. "hecoos"
          means Beijing lanjing technology co., ltd. and/or any of its related services that may be operating
          affiliates. "User" means the user of the hecoos service, also referred to as "you" in this agreement.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>1.2 hecoos services, including but not limited to online media, Internet value-added, interactive
          entertainment, advertising and other products and services, shall be subject to the actual services provided
          by hecoos (hereinafter referred to as the "service").</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>1.3 this agreement also includes the hecoos privacy policy, and when you use a particular hecoos service, the
          service may have a separate agreement, relevant business rules, etc. (hereinafter collectively referred to as
          the "separate agreement"). The above content, once published, shall be an integral part of this agreement and
          you shall also abide by it. Your acceptance of any of the foregoing separate agreements shall be deemed to be
          your entire acceptance of this agreement. Your acceptance of this agreement is your acceptance of the hecoos
          privacy policy.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>Account number and password</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>2.1 you may need to register an account when using the service.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>2.2 you shall properly keep your account and password. Exit safely after use. Due to improper storage, you
          may be responsible for the theft of stolen number or password.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>2.3 you shall ensure that the contents and forms of nicknames, avatars, signatures, messages, pictures,
          profiles and other information comply with laws, regulations, relevant policies, public order and good
          customs, social ethics and hecoos rules, and will not infringe upon the legitimate rights and interests of any
          subject.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>Protection of user's personal information</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>3.1 protection of user's personal information is a basic principle of hecoos.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>3.2 hecoos will collect, use, store and share your personal information in accordance with this agreement and
          the hecoos privacy policy.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>3.3 you may need to fill in some necessary information when registering an account or using the service. If
          national laws and regulations have special provisions, you need to fill in real identity information. If the
          information you fill in is incomplete, you may not be able to use the service or may be restricted in the
          process of using the service.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>Iv. How to use the service</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>4.1 your rights under the terms of this agreement are not transferable.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>4.2 you may not use any way (including but not limited to the third party software, plug-ins, plugins,
          system, equipment, etc.) our services for interference, destroy, modify, or other influences, nor by any third
          party software, plug-ins, plugins, system, equipment, etc. Log in or use the services, view and get this
          service included in the hecoos, hecoos partners or any relevant information, data, users, etc.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>Five, advertising,</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>5.1 you agree that hecoos may send or display advertisements or other information (including commercial and
          non-commercial information) to you by itself or by a third party through SMS, E-mail or electronic
          information, and the specific sending and display form, frequency and content of advertisements or other
          information shall be subject to the actual provision of hecoos.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>5.2 hecoos shall carry out advertising business in accordance with relevant laws and regulations. You agree
          that you shall carefully judge the authenticity and reliability of the advertisements appearing in the service
          and, except as expressly provided by law, you shall be responsible for the actions performed in connection
          with such advertisements.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>Service fee</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>6.1 part of the services of hecoos are provided for a fee, or hecoos may provide certain services for a fee
          in the future. If you use the charging service, please comply with the relevant agreement.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>6.2 hecoos may modify and change the charging standard and mode of charging services according to actual
          needs, and hecoos may start charging some free services. hecoos will notify or announce such modifications,
          changes or fees on the appropriate service page prior to the commencement of such charges. If you do not agree
          with the above modification, change or paid content, you should stop using the service.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>6.3 hecoos reserves the right not to provide refund or fee adjustment to the original paying users when
          hecoos reduces the charging standard or changes the charging service to free service.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>Products or services provided by third parties</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>When using the products or services provided by a third party on the hecoos platform, you shall comply with
          the user agreement of the third party in addition to the provisions of this agreement. hecoos and a third
          party shall be responsible for the possible disputes within the scope of legal provisions and agreements.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>Provide services based on software</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>8.1 hecoos gives you a personal, non-transferable and non-exclusive license for software that you may need to
          download during the use of the service. You may use the software only for the purpose of using the service. If
          you obtain software from a third party that is not authorized by hecoos or an installation program with the
          same name as the software, hecoos cannot guarantee that the software or service will work properly and will
          not be responsible for any loss caused to you as a result.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>8.2 hecoos may update the software from time to time as required. You should update the software to the
          latest version, otherwise hecoos does not guarantee that the software or service will work properly.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>Intellectual property rights</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>9.1 the intellectual property rights of the content provided by hecoos in the service (including but not
          limited to web pages, texts, pictures, audio, video, charts, computer software, etc.) shall be owned by
          hecoos, and the intellectual property rights of the content generated by users in using the service shall be
          owned by users or the relevant right holders, unless otherwise agreed between you and hecoos.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>9.2 the above-mentioned intellectual property rights are protected by laws and regulations and shall not be
          used in any form without the written permission of the right holder, nor be used as the basis for the creation
          of derivative works.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>X. illegal behaviors and handling of users</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>10.1 you shall abide by laws and regulations when using the service, and shall not make, copy, publish or
          disseminate information containing the following contents or engage in relevant activities, or provide
          convenience for making, reproducing, publishing or disseminating information containing the following
          contents:</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>(1) those who oppose the basic principles set forth in the constitution.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>(2) endanger state security, divulge state secrets, subvert state power or undermine national unity.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>(3) damaging the honor and interests of the state.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>(4) incites ethnic hatred and discrimination and destroys ethnic unity.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>(5) sabotaging the state's religious policies and promoting heresy and feudal superstition.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>(6) spreading rumors, disturbing social order and undermining social stability.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>(7) spreading obscenity, pornography, gambling, violence, murder, terror or instigation to commit crimes.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>(8) insult or slander others and infringe upon the legitimate rights and interests of others.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>(9) violating the requirements of the "seven bottom lines" of laws and regulations, the socialist system,
          national interests, citizens' legitimate rights and interests, social public order, morals and customs, and
          information authenticity.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>(10) prohibited by relevant laws and regulations or this agreement, relevant agreements and rules.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>10.2 if you use the service in violation of relevant laws and regulations or provisions of this agreement,
          the relevant state organs or agencies may impose administrative penalties, pursue criminal responsibilities or
          take other sanctions against you and ask for assistance from hecoos. Therefore, if any damage is caused to you
          or others, you shall bear all the responsibility and hecoos shall not bear any responsibility.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>10.3 in case of any breach of this agreement, hecoos shall have the right to independently judge and take
          appropriate measures, including but not limited to removing, blocking or disconnecting relevant content by
          technical means, suspending or terminating the services provided to you.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>10.4 you shall be solely liable for any loss of any subject (including hecoos) caused by your breach of this
          agreement.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>Comply with laws and regulations</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>11.1 in using the service, you shall abide by the relevant laws, regulations, public order and good customs
          of the People's Republic of China. Otherwise, you should assume responsibility for this independently.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>11.2 you shall avoid any violation of laws and regulations or involvement in political and public events
          caused by the use of the service by hecoos, otherwise hecoos shall have the right to suspend or terminate the
          service for you.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>Force majeure and other exemptions</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>12.1 during the use of the service, the service may be affected by force majeure and other risk factors.
          Force majeure events, including but not limited to natural disasters such as floods, earthquakes, epidemics
          and storms, as well as social events such as war, unrest, government actions, limitations on existing
          technologies, etc. In the event of the above situation, hecoos will strive for timely treatment, but the
          resulting loss to you hecoos in the scope of legal exemption.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>12.2 to the extent permitted by law, hecoos shall not be liable for service interruption or obstruction
          caused by:</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>(1) improper operation by the user or use of the service by the user in a non-hecoos authorized manner.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>(2) outdated program versions, aging equipment and/or compatibility problems.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>(3) be damaged by computer virus, Trojan horse or other malicious programs, hacker attacks.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>(4) failure of user or hecoos computer software, systems, hardware and communication lines.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>(5) other circumstances which cannot be controlled or reasonably foreseen by hecoos.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>12.3 in the process of using the service, you may encounter risks caused by network information or other user
          behaviors. hecoos shall not be liable for the authenticity and legality of such information or the damages
          caused to you by infringement. These risks include, but are not limited to:</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>(1) anonymous or pseudonymous information containing threatening, defamatory, offensive or illegal content
          from others.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>(2) suffer any psychological, physical and economic loss caused or possible to be caused by others'
          misleading, cheating or other.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>(3) other risks caused by network information or user behavior.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>12.4 hecoos shall have the right to deal with the illegal contents according to this agreement, and such
          right shall not constitute an obligation or commitment of hecoos, and hecoos shall not guarantee that the
          illegal behaviors shall be found in time or dealt with accordingly.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>Xiii. Effectiveness and modification of the agreement</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>13.1 your use of the services shall be deemed to have read and be bound by this agreement.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>13.2 hecoos shall have the right to modify the terms of this agreement if necessary. You can refer to the
          latest version of the terms of the agreement on the relevant service page. If you continue to use the software
          or services provided by hecoos after the terms of this agreement have been changed, you will be deemed to have
          accepted the changed agreement.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>Change, interruption and termination of the service</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>14.1 you understand and agree that hecoos may make changes to the service content or may interrupt, suspend
          or terminate the service based on business strategy adjustment or other reasons.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>14.2 in case of merger, division, acquisition or asset transfer of hecoos, hecoos may transfer the relevant
          assets under the service to a third party; hecoos may also, without notice to you, transfer part or all of the
          services and the corresponding rights and obligations under this agreement to third parties for operation or
          performance.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>14.3 it is your responsibility to back up the data stored in the service. If your service is terminated,
          hecoos has the right to permanently delete your data from the server, except as otherwise provided by laws and
          regulations. hecoos has no obligation to provide or return data to you after the suspension or termination of
          the service.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>15. Terms of use of persons without or with limited capacity for civil conduct</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>15.1 users with incomplete civil capacity shall read this agreement and use the service under the
          guardianship and guidance of their guardians.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>15.2 users with incomplete capacity for civil conduct shall pay attention to the following matters when using
          the service, enhance safety awareness and strengthen self-protection:</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>(1) recognize the difference between the online world and the real world, and avoid being addicted to the
          Internet, which will affect our daily study and life.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>(2) when filling in personal information, strengthen the awareness of personal protection, so as not to cause
          harassment to personal life by undesirable elements.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>(3) under the guidance of guardians or teachers, learn to use the Internet correctly.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>(4) avoid strangers to meet at random or participate in social activities, so as to avoid criminals
          opportunities to endanger their own safety.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>15.3 the guardian and the school shall give more guidance to users with incomplete civil capacity to use the
          service.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>16. Application and jurisdiction of law</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>16.1 the agreement is executed in haidian district, Beijing, PRC.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>16.2 the formation, effectiveness, performance, interpretation and dispute resolution of this agreement shall
          be governed by the laws of mainland China.</p>
        <p><br></p>
        <p><br></p>
        <p><br></p>
        <p>16.3 any dispute or dispute between you and hecoos shall first be settled through friendly negotiation; If no
          agreement can be reached through negotiation, you agree to submit the dispute or dispute to the competent
          people's court of the place where this agreement is signed (that is, Beijing, China).</p>
        <p><br></p>
      </div>
    </div>
    <myFooter />
    <BackToTop />
  </div>
</template>
<script>
import myHeader from "@/components/en_pc/myHeader.vue";
import myFooter from "@/components/en_pc/myFooter.vue";
import BackToTop from "@/components/pc/BackToTop";

export default {
  components: { myHeader, myFooter, BackToTop },
  data() {
    return {};
  },
  methods: {},
  mounted() { },
};
</script>
<style lang="scss" scoped>
.policy_warp {
  background-color: #dedede;

  .policy_content {
    width: 1210px;
    margin: 0 auto;
    padding: 80px 0;

    h3 {
      font-family: '微软雅黑';
      font-size: 30px;
      margin-bottom: 30px;
    }

    p {
      font-family: '微软雅黑';
      font-size: 18px;
      line-height: 32px;
      color: #333;
    }
  }
}
</style>